import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-welcometwo',
  templateUrl: './welcometwo.component.html',
  styleUrls: ['./welcometwo.component.scss'],
})
export class WelcometwoComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
